"use strict";

const { default: Swal } = require("sweetalert2");
const config = require('../../../../../config/locales_json/packs/private/recruiters/recruiters.json');
const language = $('body').data("language");

// Class definition

var RecruitersDatatable = function() {
  var _typeUser;
  // Private functions
  var _init = function() {
    var pathClients = document.location.pathname
    _typeUser = $('#kt_datatable_recruiters').hasClass("admin") ? "admin" : "recruiter"
    var isMultiAccount = $('#kt_datatable_recruiters').hasClass("is_multi_account")

    var datatable = $('#kt_datatable_recruiters').KTDatatable({
      // datasource definition
      data: {
        type: 'remote',
        source: {
          read: {
            url: pathClients+'/get_recruiters.json',
            method: 'GET',
            map: function(data) {
              const totalText = getTranslationValue(config, [language, "RecruitersDatatable", "data", "total_text"], " Total"); 
              $("#kt_subheader_total").html(data.length + totalText)
              
              setTimeout(() => {
                $('div#kt_datatable_recruiters .tp').tooltip('enable');
              }, 2000);

              return data
            }
          },
        },
        search: true,
        pageSize: 10, // display 20 records per page
        serverPaging: true,
        serverFiltering: true,
        serverSorting: true
      },

      // layout definition
      layout: {
          scroll: false, // enable/disable datatable scroll both horizontal and vertical when needed.
          footer: false, // display/hide footer
      },

      // column sorting
      sortable: false,

      pagination: true,

      search: {
        input: $('#kt_subheader_oferts_search_form'),
        delay: 400,
        key: 's'
      },

      translate: {
        records: {
          processing: getTranslationValue(config, [language, "RecruitersDatatable", "translate", "records-processing"],'Cargando...'),
          noRecords: getTranslationValue(config, [language, "RecruitersDatatable", "translate", "records-noRecords"],'No hay reclutadores')
        },
        toolbar: {
          pagination: {
            items: {
              default: {
                first: getTranslationValue(config, [language, "RecruitersDatatable", "toolbar", "default-first"], 'Primero'),
                prev: getTranslationValue(config, [language, "RecruitersDatatable", "toolbar", "default-prev"], 'Anterior'),
                next: getTranslationValue(config, [language, "RecruitersDatatable", "toolbar", "default-next"], 'Siguiente'),
                last: getTranslationValue(config, [language, "RecruitersDatatable", "toolbar", "default-last"], 'Último'),
                more: getTranslationValue(config, [language, "RecruitersDatatable", "toolbar", "default-more"], 'Más páginas'),
                input: getTranslationValue(config, [language, "RecruitersDatatable", "toolbar", "default-input"], 'Página number'),
                select: getTranslationValue(config, [language, "RecruitersDatatable", "toolbar", "default-select"], 'Selecciona el tamaño de la página')
              },
              info: getTranslationValue(config, [language, "RecruitersDatatable", "toolbar", "info"], 'Mostrando {{start}} - {{end}} de {{total}} reclutadores')
            }
          }
        }
      },

      // columns definition
      columns: [{
        field: 'full_name',
        title: getTranslationValue(config, [language, "RecruitersDatatable", "columns", "full_name_title"],'Nombre'),
        width: 200,
        template: function(data) {
          var output = '<div class="font-weight-bolder mb-0">'+ data.full_name + renderClientNames(data, isMultiAccount, _typeUser) +'</div>';

          return output;
        }
      },{
        field: 'email',
        title: getTranslationValue(config, [language, "RecruitersDatatable", "columns", "email_title"],'Email'),
        width: 200,
        template: function(data) {
          var output = '<div class="font-weight-bolder mb-0">'+ data.email +'</div>';

          return output;
        }
      },{
        field: 'Actions',
        title: getTranslationValue(config, [language, "RecruitersDatatable", "columns", "Actions", "title"],'Acciones'),
        sortable: false,
        width: 130,
        overflow: 'visible',
        autoHide: false,
        template: function(row) {
          var urlEdit = _typeUser == "admin" ? '/admin/empresas/'+row.company_id+'/reclutadores/'+ row.id +'/edit' : '/empresa/reclutadores/'+ row.id +'/edit'
          var slugClient = _typeUser == "admin" ? 'data-slug="'+row.company_id+'"' : ''

          if(!row.is_archived && !row.is_own){
            const editText = getTranslationValue(config, [language, "RecruitersDatatable", "columns", "Actions", "edit_text"],'Editar');
            const deleteText = getTranslationValue(config, [language, "RecruitersDatatable", "columns", "Actions", "delete_text"],'Eliminar');

            if(row.counter_postulations > 0){
              var output = '<div class="d-flex align-items-center container-actions-table">\
                <a href="'+urlEdit+'" class="icon tp mr-5" data-toggle="tooltip" data-theme="dark" title="'+editText+'" ><i class="far fa-edit"></i></a>\
                <button type="button" class="icon delete-button not-delete tp" data-toggle="tooltip" data-theme="dark" title="'+deleteText+'" data-id="'+ row.id +'" '+ slugClient +' data-toggle="modal" data-target="#delete_recruiter_modal">\
                  <i class="fas fa-trash-alt"></i>\
                </button>\
              </div>';
            } else {
              var output = '<div class="d-flex align-items-center container-actions-table">\
                <a href="'+urlEdit+'" class="icon tp mr-5" data-toggle="tooltip" data-theme="dark" title="'+editText+'" ><i class="far fa-edit"></i></a>\
                <button type="button" class="icon delete-button tp" data-toggle="tooltip" data-theme="dark" title="'+deleteText+'" data-id="'+ row.id +'" '+ slugClient +' data-toggle="modal" data-target="#delete_recruiter_modal">\
                <i class="fas fa-trash-alt"></i>\
                </button>\
              </div>';
            }
          } else {
            var output = '<div class="d-flex align-items-center container-actions-table">\
              </div>';
          }

          return output;
        }
      }],
    });
  };

  /*************
    * ELIMINAR RECLUTADOR
    *
    * - Logica de activacion de modal,
    * - Asignacion de informacion a hidden field del modal
    * - Validacion y ejecución del formulario
    */
  var _delete_recruiter = function() {
    // Al hacer click en eliminar una oferta
    $("#kt_datatable_recruiters").on("click", ".delete-button", function(e){
      $('#delete_recruiter_modal').modal('toggle')
      // Obtiene el id de la oferta
      var recruiterID = $(this).attr("data-id")
      // Asigna el id de la oferta en el campo hidden del modal
      $("#delete_recruiter_modal #hidden_modal_id").val(recruiterID)
      // Se asigna la url correspondiente, si el usuario es admin
      if(_typeUser == "admin"){
        var slug = $(this).attr("data-slug")
        var url = '/admin/empresas/'+slug+'/reclutadores/'+recruiterID+'/destroy';
      // De lo contrario si es reclutador
      } else {
        var url = '/empresa/reclutadores/'+ recruiterID;
      }
      // Se asigna al form la action
      $("#form_modal_delete_recruiter").attr("action", url)
      // Si la oferta se debe archivar porque tiene postulaciones
      if($(this).hasClass("not-delete")){
        const descriptionText = getTranslationValue(config, [language, "_delete_recruiter", "description_text"],"Esta oferta contiene postulaciones, no se puede eliminar pero si quedará archivada. Esta acción no se puede revertir.");
        const btnText = getTranslationValue(config, [language, "_delete_recruiter", "btn_text"],"Archivar");
        
        // Modifica la descripcion del modal
        $("#delete_recruiter_modal .modal-body .description").text(descriptionText)
        // Modifica el texto del boton
        $("#delete_recruiter_modal .modal-footer #send_modal_delete_recruiter_form").text(btnText)
        // Agrega la clase not-delete para que al enviar el formulario muestre el texto de "Archivando..."
        $("#delete_recruiter_modal .modal-footer #send_modal_delete_recruiter_form").addClass("not-delete")
      // Si la oferta debe eliminarse modifica la info del modal por si anteriormente el modal fue abierto
      // por alguna oferta que se debio archivar
      } else {
        const descriptionText = getTranslationValue(config, [language, "_delete_recruiter", "else_description_text"],"Esta acción no se puede revertir.");
        const btnText = getTranslationValue(config, [language, "_delete_recruiter", "else_btn_text"],"Eliminar");

        // Modifica la descripcion del modal
        $("#delete_recruiter_modal .modal-body .description").text(descriptionText)
        // Modifica el texto del boton
        $("#delete_recruiter_modal .modal-footer #send_modal_delete_recruiter_form").text(btnText)
        // Quita la clase not-delete para que al enviar el formulario muestre el texto de "Eliminando..."
        $("#delete_recruiter_modal .modal-footer #send_modal_delete_recruiter_form").removeClass("not-delete")
      }

    })

    // Al cerrar el modal limpia la url y el hidden
    $("#delete_recruiter_modal .close").on("click", function(e){
      cleanRecruiterModalForm()
    })

    // Al hacer click en confirmar eliminacion de oferta
    $("#delete_recruiter_modal #cancel_modal_delete_recruiter_form").on("click", function(e){
      cleanRecruiterModalForm()
    })

    // Al hacer click en enviar oferta
    $("#delete_recruiter_modal #send_modal_delete_recruiter_form").on("click", function(e){
      // Valida que el campo hidden tenga información
      var recruiterID = $("#delete_recruiter_modal #hidden_modal_id").val()
      // Si tiene informacion ejecuta el formulario
      if(recruiterID.length > 0) {
        // Se desabilitan las acciones
        // Si se esta archivando una oferta
        if($(this).hasClass("not-delete")){
          const btnText = getTranslationValue(config, [language, "_delete_recruiter", "on_clicl_send_modal_delete_recruiter_form", "archived_text"],"Archivando...");
          // Cambia el texto del boton a Archivando
          $(this).addClass("disabled").text(btnText)
        // De lo contrario esta eliminando una oferta
        } else {
          const btnText = getTranslationValue(config, [language, "_delete_recruiter", "on_clicl_send_modal_delete_recruiter_form", "delete_text"],"Eliminando...");
          // Cambia el texto del boton a Eliminando
          $(this).addClass("disabled").text(btnText)
        }

        $("#delete_recruiter_modal #cancel_modal_delete_recruiter_form").addClass("disabled")
        $("#delete_recruiter_modal #close_delete_recruiter_modal").addClass("disabled")
        $("#form_modal_delete_recruiter").submit()
      } else {
        const errorText = getTranslationValue(config, [language, "_delete_recruiter", "on_clicl_send_modal_delete_recruiter_form", "error_text"],"Hubo un problema y no se pudo eliminar la oferta. Por favor intente más tarde.");
        // Si no se puede eliminar
        $(".modal-body").find(".error-modal").remove()
        $(".modal-body").prepend('<div class="error-modal"><i class="fas fa-times-circle"></i><p>'+errorText+'</p></div>')
      }
    })

    // Limpia el campo hidden y la url del form
    function cleanRecruiterModalForm(){
      // Limpia si hay errores
      $(".modal-body").find(".error-modal").remove()
      // Limpia el campo hidden
      $("#delete_recruiter_modal #hidden_modal_id").val(null)
      // Se limpia la url correspondiente
      var url = '';
      $("#form_modal_delete_recruiter").attr("action", url)
    }
    /*************
    * FIN ELIMINAR OFERTA
    */
  }

  return {
    // public functions
    init: function() {
        _init();
        _delete_recruiter();
        // _validation_date();
    },
  };
}();

$(document).ready(function() {
  if($("#kt_datatable_recruiters").length > 0){
    RecruitersDatatable.init();
  }
});

function renderClientNames(recruiter, isMultiAccount, typeUser) {
  if (typeUser == 'recruiter' && !isMultiAccount) return '';
  if (!recruiter['active_clients']) return ' | Sin Clientes Activos';

  let clientNames = [];

  if (Array.isArray(recruiter['active_clients']) && recruiter['active_clients'].length > 0) {
    clientNames = recruiter['active_clients'].map(function (client) {
      return client.name;
    });
  }

  return ' | '+clientNames.join(', ');
}

function getTranslationValue(config, keys, defaultValue) {
	if (keys.length <= 1) return defaultValue;
  
	let currentTranslation;
	let firstIteration = true;
  
	for (let key of keys) {

	  if (firstIteration) {

      if (config[key]) {
        currentTranslation = config[key];
        firstIteration = false;
      } else {
        firstIteration = false;
        return defaultValue;
      }
	  } else {
      
      if (currentTranslation[key]) {
        currentTranslation = currentTranslation[key];
      } else {
        return defaultValue;
      }
	  }
	}

	return currentTranslation;
}
